import * as Sentry from "@sentry/react"
import { createRouter as createTanStackRouter } from "@tanstack/react-router"
import { routeTree } from "./routeTree.gen"

export function getRouter() {
  const router = createTanStackRouter({
    routeTree,

    scrollRestoration: true,
    defaultPreload: "intent",
    defaultPreloadStaleTime: 0,
  })
  if (import.meta.env.VITE_ENABLE_SENTRY === "true") {
    Sentry.init({
      dsn: "https://444d9d6dc2838f79b8b73779a96bc42a@o4504811898077184.ingest.us.sentry.io/4512086698033152",
      integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router)],
      tracesSampleRate: 1.0,
    })
  }

  return router
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>
  }
}
